"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.teamInternalReferenceFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
exports.teamInternalReferenceFactory = Factory.Sync.makeFactory({
    _links: [],
    label: 'Test TIR',
    status: 'Active',
    reference_type: 'team',
    team_id: Factory.each(i => uuid_1.v4()),
    team_org_id: Factory.each(i => i + 1),
    reference_team_id: Factory.each(i => uuid_1.v4()),
});
